import { Navigate } from "react-router-dom";
import { useAuthContext } from "./AuthProvider";

const PermissionRoute = ({
  children,
  permission,
}: {
  children: JSX.Element;
  permission: string;
}) => {
  const { hasPermission } = useAuthContext();

  if (!hasPermission(permission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PermissionRoute; 